import { IAdobeInteraction } from "@abbvie-epi/common/adobe-analytics";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";
import { SpecialtyService } from "../../services/specialty.service";

@Component({
    selector: "app-hcp",
    templateUrl: "./hcp.component.html",
    styleUrls: ["./hcp.component.scss"]
})
export class HcpComponent implements OnInit {
    @Output() validHcp: EventEmitter<void> = new EventEmitter<void>();
    @Output() modalShouldClose: EventEmitter<void> = new EventEmitter<void>();

    @Output() answerSubmit = new EventEmitter();

    private initialSpecialty: boolean = true;

    public selectedSpeciality: string;
    public speciality: boolean = false;
    public specialityOptions: string[] = [
        "MD-Internal Medicine",
        "MD-Gastroenterology",
        "MD-Family Medicine",
        "MD-Oncology",
        "MD-Other",
        "DO-Osteopathy",
        "Registered Nurse (RN)",
        "Nurse Practitioner",
        "Physician Assistant",
        "Other"
    ];
    public otherSpecialty: string;

    constructor(
        private specialtyService: SpecialtyService,
        private router: Router,
        private analyticsHelper: AnalyticsHelperService
    ) {}

    ngOnInit(): void {}

    public isValid(valid: boolean) {
        if (valid) {
            this.validHcp.emit();
        }
    }

    public chooseSpeciality() {
        this.speciality = true;

        this.trackConfirmHCP("yes");
    }

    public closeModal() {
        this.specialtyService.closeHcpModal();
    }

    public getSelectedAnswer(selection: string) {
        this.selectedSpeciality = selection;

        const overrides: IAdobeInteraction = {
            link: {
                name: `What is your specialty? ${selection}`,
                title: selection
            },
            form: {
                fieldValue: selection
            }
        };

        if (this.initialSpecialty) {
            this.analyticsHelper.trackInteraction("what-is-your-specialty-initial", overrides);
            this.initialSpecialty = false;
        } else {
            this.analyticsHelper.trackInteraction("what-is-your-specialty-update", overrides);
        }
    }

    public trackConfirmHCP(response: "yes" | "no" | "close"): void {
        this.analyticsHelper.trackInteraction("confirm-us-hcp-" + response);
    }

    public submitSpecialty() {
        if (
            (this.selectedSpeciality && this.selectedSpeciality !== "Other") ||
            (this.selectedSpeciality === "Other" && this.otherSpecialty)
        ) {
            if (this.selectedSpeciality === "Other") {
                sessionStorage.setItem("hcpSpecialty", this.selectedSpeciality);
            } else if (this.selectedSpeciality && this.selectedSpeciality !== "Other") {
                sessionStorage.setItem("hcpSpecialty", this.selectedSpeciality);
            }

            const analyticsOverrides: IAdobeInteraction = {
                form: {
                    fieldValues: `What is your specialty?: ${this.selectedSpeciality}`
                }
            };
            this.analyticsHelper.trackInteraction("what-is-your-specialty-submit", analyticsOverrides);

            this.isValid(true);
            this.closeModal();

            // navigate to start-screening
            this.router.navigate(["screening-tool-landing"], { fragment: "start-screening" });
        }
    }
}
